import { Injectable, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { PersonRoleEnum } from '../Models/OtherClasses';
import * as moment from 'moment';

@Injectable()
export class ConfigService {

	constructor(
		@Inject("myconfig") private apiConfig: any,
		private myRouter: Router) {

		this.isSuperAdmin = apiConfig.isSuperAdmin;
		this.isDebug = apiConfig.isDebug;
		this.AppConfig = apiConfig.AppConfig;
		this.DefaultEmptyGuid = apiConfig.DefaultEmptyGuid;
		this.TranslateWords = apiConfig.TranslateWords;
		this.baseUrl = apiConfig.baseUrl;
		this.allTimeZones = apiConfig.allTimeZones;
		this.docUploadURL = apiConfig.docUploadURL;
		this.allowedRoles = apiConfig.AllowedRoles;
		this.gMapsApiKey = apiConfig.gMapsApiKey;
		this.viewingAsRole = apiConfig.ViewingAsRole;
		this.serverVersion = apiConfig.serverVersion;
		this.authNetClientKey = apiConfig.authNetClientKey;
		this.authNetApiLoginID = apiConfig.authNetApiLoginID;
		this.isMasterCompany = apiConfig.isMasterCompany;
		this.isHRCompany = apiConfig.isHRCompany;
		this.isLMSCompany = apiConfig.isLMSCompany;
		this.isTrackerCompany = apiConfig.isTrackerCompany;
		this.isUnlimitedLMS = apiConfig.isUnlimitedLMS;
		this.isIntroVersion = apiConfig.isIntroVersion;
		this.isDentalProgram = apiConfig.isDentalProgram;
		this.lessonUploadURL = apiConfig.lessonUploadURL;
		this.courseUploadURL = apiConfig.courseUploadURL;
		this.companyCourseUploadURL = apiConfig.companyCourseUploadURL;
		this.coverImageBaseURL = apiConfig.coverImageBaseURL;
		this.personImageBaseURL = apiConfig.personImageBaseURL;
		this.checklistRedirectURL = apiConfig.checklistRedirectURL;
		this.azureStorageBaseLessonUrl = apiConfig.azureStorageBaseLessonUrl;
		this.azureLessonBaseUrl = apiConfig.azureLessonBaseUrl;
		this.isPaid = apiConfig.isPaid;
		this.balance = apiConfig.balance;
		this.needsCC = apiConfig.needsCC;
		this.MenuPages = apiConfig.MenuPages;
		this.isSignUpCompany = apiConfig.isSignUpCompany;
	}

	public goHome() {

		this.myRouter.navigate(['/ang'], {});

	}
	public SortArray(myArray: any[], sortCriteria: ePM.Logic.SortCriteria) {
		if (!sortCriteria || !myArray || !myArray.length) {
			return myArray;
		}

		var cols: string[] = sortCriteria.sortColumn.split(',');

		return myArray.sort((a, b) => {

			for (var i = 0; i < cols.length; i++) {
				var colName = cols[i].trim();
				var firstCol = a[colName];
				var secondCol = b[colName];

				var stringChanged: boolean = false;
				if (typeof (firstCol) == "string") {
					if (!firstCol) {
						firstCol = '';
					}
					firstCol = firstCol.toLowerCase().trim();
					stringChanged = true;
				}
				if (typeof (secondCol) == "string") {
					if (!secondCol) {
						secondCol = '';
					}
					secondCol = secondCol.toLowerCase().trim();
					stringChanged = true;
				}

				if (!stringChanged) {
					//If we need to sort addresses
					if (firstCol && secondCol && typeof (firstCol) == "object" && typeof (secondCol) == "object") {
						if (firstCol.Address1) {
							var stateCompare = this.sortValue(firstCol.State, secondCol.State, sortCriteria.sortDirection);
							if (stateCompare == 0) {
								var cityCompare = this.sortValue(firstCol.City, secondCol.City, sortCriteria.sortDirection);
								if (cityCompare == 0) {
									var addrCompare = this.sortValue(firstCol.Address1, secondCol.Address1, sortCriteria.sortDirection);
									if (addrCompare == 0) {
										var addrCompare2 = this.sortValue(firstCol.Address2, secondCol.Address2, sortCriteria.sortDirection);
										if (addrCompare != 0) {
											return addrCompare2;
										}
									} else {
										return addrCompare;
									}
								} else {
									return cityCompare;
								}
							} else {
								return stateCompare;
							}
						}
					}
				}
				if (firstCol != secondCol) {
					return this.sortValue(firstCol, secondCol, sortCriteria.sortDirection);
				}
			}
			return 0;
		});
	}

	private sortValue(a: any, b: any, sortType: string): number {
		if (a == b) {
			return 0;
		}

		if (sortType === 'desc') {
			return this.alphanum(b, a);
		} else {
			return this.alphanum(a, b);
		}

		//if (sortType === 'desc') {
		//	return a < b ? 1 : -1;
		//} else {
		//	return a < b ? -1 : 1;
		//}
	}

	private isNumber(char: any): boolean {
		return !isNaN(parseFloat(char));
	}

	private isValidDate(date: any) {
		if (date) {
			var a = new Date(date);
			return Object.prototype.toString.call(a) === "[object Date]" && !isNaN(Number(a));
		}
		return false;
	}

	private alphanum(s1: any, s2: any): number {
		if (s1 == null || s2 == null) {
			if (s1 == null && s2 == null) {
				return 0;
			} else {
				return s1 == null ? -1 : 1;
			}
		}

		if (this.isValidDate(s1) && this.isValidDate(s2)) {
			return s1 > s2 ? 1 : s1 < s2 ? -1 : 0;
		}
		if (this.isNumber(s1) && this.isNumber(s2)) {
			var thisNumericChunk: number = parseFloat(s1);
			var thatNumericChunk: number = parseFloat(s2);
			return thisNumericChunk - thatNumericChunk;
		}
		var len1: number = s1.length;
		var len2: number = s2.length;
		var marker1: number = 0;
		var marker2: number = 0;

		// Walk through two the strings with two markers.
		while (marker1 < len1 && marker2 < len2) {
			var ch1: string = s1[marker1];
			var ch2: string = s2[marker2];

			// Some buffers we can build up characters in for each chunk.
			var space1: string[] = [];
			var loc1: number = 0;
			var space2: string[] = [];
			var loc2: number = 0;

			// Walk through all following characters that are digits or
			// characters in BOTH strings starting at the appropriate marker.
			// Collect char arrays.
			do {
				space1[loc1++] = ch1;
				marker1++;

				if (marker1 < len1) {
					ch1 = s1[marker1];
				} else {
					break;
				}
			} while (this.isNumber(ch1) == this.isNumber(space1[0]));

			do {
				space2[loc2++] = ch2;
				marker2++;

				if (marker2 < len2) {
					ch2 = s2[marker2];
				} else {
					break;
				}
			} while (this.isNumber(ch2) == this.isNumber(space2[0]));

			// If we have collected numbers, compare them numerically.
			// Otherwise, if we have strings, compare them alphabetically.
			var str1: string = space1.join('');
			var str2: string = space2.join('');

			var result: number;

			if (this.isNumber(space1[0]) && this.isNumber(space2[0])) {
				var thisNumericChunk: number = parseFloat(str1);
				var thatNumericChunk: number = parseFloat(str2);
				result = thisNumericChunk == thatNumericChunk ? 0 : (thisNumericChunk > thatNumericChunk ? 1 : -1);
			} else {
				result = str1 == str2 ? 0 : (str1 > str2 ? 1 : -1)
			}

			if (result != 0) {
				return result;
			}
		}
		return len1 - len2;
	}

	baseCookieName: string = 'ePMC';
	setCookie(cname: string, cvalue: string, exdays: number) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = this.baseCookieName + cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie(cname: string, skipBaseName: boolean) {
		var name = skipBaseName ? cname + '=' : this.baseCookieName + cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	
	public IsEmptyGuid(id: System.Guid) {
		if (id) {
			if (id != this.DefaultEmptyGuid) {
				return false;
			}
		}
		return true;
	}

	public IsUserInRole(roleSystemCode: string) {
		var roles: string[] = (roleSystemCode || '').split(',');
		for (var i = 0; i < roles.length; i++) {
			var isOk = this.allowedRoles.indexOf(roles[i].toUpperCase()) >= 0;
			if (isOk) {
				return true;
			}
		}
		if (PersonRoleEnum.SUPERADMIN == roleSystemCode) {
			return this.isSuperAdmin;
		}else if (!isOk) {
			return this.allowedRoles.indexOf(PersonRoleEnum.ADMIN) >= 0
				|| this.allowedRoles.indexOf(PersonRoleEnum.SUPERADMIN) >= 0;
		}
		return false;
	}

	private static alreadyPoppedUp = false;
	public shouldShowVersionAlert(versionNum: string) {
		if (!ConfigService.alreadyPoppedUp && this.serverVersion != versionNum) {
			ConfigService.alreadyPoppedUp = true;
			return true;
		}
		return false;
	}

	private static alreadyPoppedUpMoney = false;
	public shouldShowMoneyAlert(isPaidStr: any) {
		var isPaid = isPaidStr && JSON.parse(isPaidStr.toLowerCase());
		if (this.isPaid != isPaid) {
			this.isPaid = isPaid;
			if (!isPaid) {
				if (!ConfigService.alreadyPoppedUpMoney) {
					ConfigService.alreadyPoppedUpMoney = true;
					return true;
				}
			}
		}
		return false;
	}

	//https://stackoverflow.com/questions/16597853/combine-date-and-time-string-into-single-date-with-javascript
	CombineDateAndTime(date: any, time: any): Date {
		if (typeof (date) == "string") {
			date = new Date(date);
		}

		if (!time) {
			return date;
		}
		if (typeof (time) == "string") {
			if (time.indexOf('Z') > 0 || time.indexOf('T') > 0) {
				try {
					time = new Date(time);
				} catch {
					time = this.parseTime(time, date);
				}
			} else {
				time = this.parseTime(time, date);
			}
		}
		var timeString = this.padNumber(time.getHours()) + ':' + this.padNumber(time.getMinutes()) + ':00';
		var year = date.getFullYear();
		var month = date.getMonth() + 1; // Jan is 0, dec is 11
		var day = date.getDate();
		var dateString = '' + year + '-' + this.padNumber(month) + '-' + this.padNumber(day);
		var datec = dateString + 'T' + timeString;
		var combined = new Date(datec);

		return combined;
	}

	//http://www.timlabonne.com/2013/07/parsing-a-time-string-with-javascript/
	parseTime(timeStr: string, dt: Date): Date {
		if (!dt) {
			dt = new Date();
		}

		var time = timeStr.match(/(\d+)(?::(\d\d))?\s*(p?)/i);
		if (!time) {
			return null;
		}
		var hours = parseInt(time[1], 10);
		if (hours == 12 && !time[3]) {
			hours = 0;
		}
		else {
			hours += (hours < 12 && time[3]) ? 12 : 0;
		}

		dt.setHours(hours);
		dt.setMinutes(parseInt(time[2], 10) || 0);
		dt.setSeconds(0, 0);
		return dt;
	}

	padNumber(value: number) {
		if (this.isNumber(value)) {
			return this.leftPad(value.toString(), 2);
		} else {
			return "";
		}
	}

	//https://codepen.io/daniellmb/pen/JKGamY
	leftPad(str: string, len: number, ch = '0'): string {
		len = len - str.length + 1;
		return len > 0 ?
			new Array(len).join(ch) + str : str;
	}

	//https://stackoverflow.com/questions/20156/is-there-an-easy-way-to-create-ordinals-in-c
	ordinalNumber(num: number) {
		if (num <= 0) return num.toString();

		switch (num % 100) {
			case 11:
			case 12:
			case 13:
				return num + "th";
		}

		switch (num % 10) {
			case 1:
				return num + "st";
			case 2:
				return num + "nd";
			case 3:
				return num + "rd";
			default:
				return num + "th";
		}
	}


	dayName(date: moment.Moment) {
		switch (date.day()) {
			case 0:
				return 'Sunday';
			case 1:
				return 'Monday';
			case 2:
				return 'Tuesday';
			case 3:
				return 'Wednesday';
			case 4:
				return 'Thursday';
			case 5:
				return 'Friday';
			case 6:
				return 'Saturday';
			default:
				return '';
		}
	}

	ordinalWeekDay(date: moment.Moment) {
		var myVal: number = date.day();
		var dayNum = date.date();
		var trackDate = new Date(date.year(), date.month(), 1);
		var weekNumber: number = 1;
		while (trackDate.getDate() < dayNum) {
			if (trackDate.getDay() == myVal) {
				weekNumber++;
			}
			trackDate = new Date(date.year(), date.month(), trackDate.getDate() + 1);
		}
		return this.ordinalNumber(weekNumber);
	}

	monthName(date: moment.Moment) {
		switch (date.month()) {
			case 0:
				return 'January';
			case 1:
				return 'February';
			case 2:
				return 'March';
			case 3:
				return 'April';
			case 4:
				return 'May';
			case 5:
				return 'June';
			case 6:
				return 'July';
			case 7:
				return 'August';
			case 8:
				return 'September';
			case 9:
				return 'October';
			case 10:
				return 'November';
			case 11:
				return 'December';

			default:
				return '';
		}
	}

	public UsesPTODays(): boolean {
		return this.AppConfig.usePTODays;
	}
	public MakeTimeQS(): string {
		return '?q=' + (new Date()).getSeconds();
	}

	public isDebug: boolean;
	public AppConfig: ConfigDict;
	public DefaultEmptyGuid: string;
	public baseUrl: string;
	public docUploadURL: string;
	public lessonUploadURL: string;
	public courseUploadURL: string;
	public companyCourseUploadURL: string;
	public coverImageBaseURL: string;
	public personImageBaseURL: string;
	public checklistRedirectURL: string;
	public azureLessonBaseUrl: string;
	public azureStorageBaseLessonUrl: string;
	public allTimeZones: TimeZoneDict;
	public TranslateWords: TranslateWordsDict;
	public isSuperAdmin: boolean;
	public allowedRoles: string[];
	public viewingAsRole: string;
	public gMapsApiKey: string;
	public serverVersion: string;
	public isMasterCompany: boolean;
	public isPaid: boolean;
	public balance: number;
	public needsCC: boolean; 
	public authNetClientKey: string;
	public authNetApiLoginID: string;
	public isHRCompany: boolean;
	public isTrackerCompany: boolean;
	public isLMSCompany: boolean;
	public isUnlimitedLMS: boolean;
	public isIntroVersion: boolean;
	public isDentalProgram: boolean;
	public isSignUpCompany: boolean;
	public MenuPages: { [key: string]: any };
}


type TranslateWordsDict = { [key: string]: any };

type ConfigDict = { [key: string]: any };

type TimeZoneDict = { [key: string]: any };
